export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: isMobile ? 35 : 23,
    right: 30,
    bottom: 35,
    left: 40,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  return {
    height,
    initialWidth,
    initialHeight,
    isMobile,
    margins,
    width,
  };
}
